import { KEYBOARD } from '../../constants/index.js';
import { useEffect } from 'react';

function useEscapeCallback(options) {
  var active = options.active,
    callback = options.callback,
    elements = options.elements;
  var allElements = Array.isArray(elements) ? elements : [elements];
  var keyListener = function keyListener(event) {
    if (event.key === KEYBOARD.ESC) {
      event.stopPropagation();
      callback();
    }
  };
  useEffect(function () {
    allElements.forEach(function (element) {
      var target = element.current;
      if (target) {
        target.addEventListener('keyup', keyListener);
      }
    });
    return function () {
      allElements.forEach(function (element) {
        var target = element.current;
        if (target) {
          target === null || target === void 0 ? void 0 : target.removeEventListener('keyup', keyListener);
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active].concat(allElements));
}

export { useEscapeCallback };
